import { Typography } from 'src/ui/common/atoms/typography';
import { media } from 'src/ui/common/mixins/media';
import { Carousel } from 'src/ui/common/molecules/carousel';
import styled, { css } from 'styled-components';

const INFO_BLOCK_WIDTH_SM = '335px';
const INFO_BLOCK_WIDTH_MD = '446px';

export const StyledTopBanner = styled.div<{ img?: string | null }>`
    width: 100%;
    position: relative;
    margin: 10px 0;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    min-width: 100%;
    max-width: 100%;
    min-height: 100%;
    max-height: 100%;
    border-radius: 4px;

    ${({ img }) =>
        img &&
        css`
            background-image: url(${img});
        `}

    ${media.sm(css`
        height: 540px;
        margin: 60px 0;
    `)}

  ${media.md(css`
        height: 650px;
        margin: 70px 0;
    `)}
`;

export const StyledWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: inherit;
    justify-content: flex-end;
    min-height: 642px;
    padding: 20px 20px 0 20px;

    ${media.sm`
        flex-direction: row;
        min-height: auto;
        padding: 16px 0 16px 16px;
        justify-content: space-between;
    `};
`;

export const StyledInfoBlock = styled.div`
    height: 100%;
    z-index: 2;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: rgba(41, 41, 41, 0.7);
    padding: 22px;
    min-height: 290px;
    border-radius: 5px;
    width: 100%;
    margin-bottom: 20px;

    button {
        width: 137px;
    }

    ${media.sm`
        width: ${INFO_BLOCK_WIDTH_SM};
        padding: 24px;
    `}

    ${media.md`
        width: ${INFO_BLOCK_WIDTH_MD};
        padding: 40px 40px 48px 40px;

        button {
            width: 177px;
        }
    `}
`;

export const StyledDescription = styled(Typography)`
    margin-top: 15px;

    ${media.md`
        margin-top: 24px;
    `}
    a {
        color: ${({ theme }) => theme.colors.pink500};
    }
`;

export const StyledCanvas = styled.canvas`
    position: absolute;
    z-index: 0;
    width: 100%;
    height: 100%;
`;

export const StyledCarousel = styled(Carousel)`
    max-width: 100%;
    margin: 56px auto 32px;

    ${media.sm`
        max-width: calc(100% - ${INFO_BLOCK_WIDTH_SM});
        margin: 0 auto;
    `}
    ${media.md`
        max-width: calc(100% - ${INFO_BLOCK_WIDTH_MD});
    `}
  & .slick-slide > div {
        width: 177px;
        min-width: 177px;
        margin: 0 12px;

        ${media.md`
            width: 290px;
            min-width: 290px;
            margin: 0 20px;
        `}
    }

    & .slick-dots {
        margin-top: 32px;
        position: static;

        ${media.sm`
            margin-top: 16px;
        `};

        ${media.md`
            margin-top: 40px;
            margin-bottom: 24px;
        `};
    }

    & .slick-dots li button::before {
        font-size: 8px;
        color: rgba(13, 12, 12, 0.75);
        opacity: 0.3;
    }

    & .slick-dots li.slick-active button::before {
        opacity: 1;
    }
`;
